/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  let serviceWorkerRegistration = null
  let lastUpdateCheck = 0
  let reloadingForUpdate = false
  const pageWasControlledAtLaunch = Boolean(navigator.serviceWorker && navigator.serviceWorker.controller)
  const minimumCheckInterval = 5 * 60 * 1000

  const checkForUpdate = (force = false) => {
    if (!serviceWorkerRegistration || !navigator.onLine) return
    const now = Date.now()
    if (!force && now - lastUpdateCheck < minimumCheckInterval) return
    lastUpdateCheck = now
    serviceWorkerRegistration.update().catch(error => {
      console.error('Unable to check for an app update:', error)
    })
  }

  // An activated worker cannot replace JavaScript already running in this
  // document. Reload once when a new worker takes control so the installed PWA
  // immediately uses the newly deployed, revisioned assets.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!pageWasControlledAtLaunch || reloadingForUpdate) return
    reloadingForUpdate = true
    window.location.reload()
  })

  window.addEventListener('online', () => checkForUpdate(true))
  window.addEventListener('pageshow', () => checkForUpdate(true))
  window.addEventListener('focus', () => checkForUpdate(true))
  document.addEventListener('visibilitychange', () => {
    // Native WebViews fire this when the shell returns from the background.
    // Force a network revalidation every time; update() is cheap when the
    // service-worker file has not changed and does not reload the order page.
    if (document.visibilityState === 'visible') checkForUpdate(true)
  })
  window.setInterval(() => {
    if (document.visibilityState === 'visible') checkForUpdate()
  }, minimumCheckInterval)

  register(`${process.env.BASE_URL}service-worker.js`, {
    registrationOptions: {
      updateViaCache: 'none'
    },
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      serviceWorkerRegistration = registration
      checkForUpdate(true)
    },
    cached () {
      // console.log('Content has been cached for offline use.')
    },
    updatefound () {
      // console.log('New content is downloading.')
    },
    updated (registration) {
      serviceWorkerRegistration = registration
      // This also upgrades users whose currently installed worker predates the
      // skipWaiting build configuration.
      if (registration.waiting) registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    },
    offline () {
      // console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
